module.exports = __webpack_public_path__ + "static/media/2.12ca5b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格选中态/2.png
// module id = 1628
// module chunks = 0